import { GetStaticProps } from "next";
import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import PageLoading from "@/src/shared/PageLoading";

export default function Custom404() {
  useEffect(() => {
    window.location.href = "/not-found";
  }, []);

  return <PageLoading isOpen />;
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    skipAppRouter: true,
    ...(await serverSideTranslations(locale))
  }
});
